import React from "react";
import className from "../../../shared/className";

export default function PatientListHead({ surveilStore }) {
  return (
    <div className="list-head">
      {surveilStore.sortableLists.map((list) => (
        <div
          {...className({
            tab: true,
            selected: surveilStore.selectedListOption.value === list,
          })}
          onClick={() => surveilStore.listChange({ value: list })}
          key={list.type + list.title}
        >
          {list.title.toUpperCase()}
        </div>
      ))}
      <div
        className="close"
        title="close"
        onClick={() => (surveilStore.showPatientList = false)}
      ></div>
    </div>
  );
}
